import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const config = {
    headers: {
        "Content-Type": "application/json",
        "x-api-token": process.env.REACT_APP_HEARSAY_TOKEN,
        "x-api-secret": process.env.REACT_APP_HEARSAY_SECRET,
        // Add other headers as needed
    },
};

export const fetchInvoices = createAsyncThunk(
    "invoices/fetchInvoices",
    async (_, { getState }) => {
        const response = await axios.get(
            "https://portal.hearsay.ca/api/invoices",
            config
        );
        if (!response.status === 200) {
            throw new Error(
                response.data.message || "Could not fetch WAAG Totals"
            );
        }
        return response.data;
    }
);

export const fetchWaagTotals = createAsyncThunk(
    "invoices/fetchWaagTotals",
    async (_, { getState }) => {
        const response = await axios.get(
            `https://portal.hearsay.ca/api/invoices/waag`,
            config
        );

        if (!response.status === 200) {
            throw new Error(
                response.data.message || "Could not fetch WAAG Totals"
            );
        }
        return response.data;
    }
);
